import useApiController from "@hooks/useApiController";

export default function useSupportController(): General.Controllers.Support {
    const { store } = useApiController("/api/support")

    return { store }
}